import React from 'react';
import {
  Button,
  Spinner,
  Col,
  Card,
  CardBody,
  Alert,
} from 'reactstrap';
import PropTypes from 'prop-types';
import Input from 'reactstrap/lib/Input';
import callDb from '../../../utils/server';

class SearchFiconum extends React.Component {
  static propTypes = {
    updateResults: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isSearching: false,
      given_name: '',
      family_name: '',
      email: '',
      isNoResult: false,
      birth_date: '',
      postal_code: '',
    };
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  searchUser = () => {
    const {
      isSearching, given_name, family_name,
    } = this.state;
    const { updateResults } = this.props;
    if (isSearching) return;
    this.setState({ isSearching: true });
    const allInfo = {
      given_name,
      family_name,
      // email: '',
    };
    callDb(allInfo, 'ficonum/search').then((result) => {
      const { data } = result;
      console.log(data);
      this.setState({ isSearching: false, isNoResult: data.length === 0 });
      updateResults(data);
    }).catch((e) => {
      console.log(e);
      this.setState({ isSearching: false, isNoResult: true });
      updateResults([]);
    });
  }

  render() {
    const {
      isSearching, given_name, family_name, email, isNoResult, birth_date, postal_code,
    } = this.state;
    return (
      <Col md="6">
        <Card>
          <CardBody>
            <h4 className="bold-text mb-20">Rechercher la présence d'un défunt dans le FICONUM :</h4>
            {/* <Alert color="info">
              <b>Phase test</b> : utiliser les noms / prénoms renseignés par défaut (Pierre Delannoy)
            </Alert> */}
            <div className="form">
              <div className="form__form-group">
                <span className="form__form-group-label">Prénom complet du défunt</span>
                <div className="form__form-group-field priority">
                  <input
                    type="text"
                    placeholder="Prénom complet du défunt"
                    value={given_name}
                    name="given_name"
                    onChange={this.onChange}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Nom de famille</span>
                <div className="form__form-group-field priority">
                  <input
                    type="text"
                    placeholder="Nom complet du défunt"
                    value={family_name}
                    name="family_name"
                    onChange={this.onChange}
                  />
                </div>
              </div>
              {/* <div className="form__form-group">
                <span className="form__form-group-label">Email</span>
                <div className="form__form-group-field priority">
                  <input
                    type="email"
                    placeholder="Adresse email du défunt"
                    value={email}
                    name="email"
                    onChange={this.onChange}
                  />
                </div>
              </div> */}
              <div className="form__form-group">
                <span className="form__form-group-label">Date de naissance</span>
                <div className="form__form-group-field priority">
                  <Input
                    name="birth_date"
                    placeholder="La date de naissance du défunt"
                    type="date"
                    value={birth_date}
                    onChange={this.onChange}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">Code postal de naissance</span>
                <div className="form__form-group-field priority">
                  <input
                    type="number"
                    placeholder="Le code postal du lieu de  naissance du défunt"
                    value={postal_code}
                    name="postal_code"
                    onChange={this.onChange}
                  />
                </div>
              </div>
            </div>
            <div className="fullWidth">
              {
                isSearching ? (
                  <Button className="semiBold" color="official">
                    <Spinner size="sm" role="status" aria-hidden="true" />
                  </Button>
                ) : (
                  <Button disabled={!given_name && !family_name && !email} onClick={this.searchUser} className="semiBold" color="official">
                    Rechercher
                  </Button>
                )
              }
              {
                isNoResult && <Alert color="danger">Aucun résultat</Alert>
              }
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default SearchFiconum;
